module.exports = __webpack_public_path__ + "img/swedishfishing.1d2f0469.jpg";